import { render, staticRenderFns } from "./ModalConfirmBlock.vue?vue&type=template&id=27179a90&scoped=true&"
import script from "./ModalConfirmBlock.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27179a90",
  null
  
)

export default component.exports